class OiAnim {
    private readonly oiAnim: HTMLElement;
    private hasScrolled: boolean;
    private observer: IntersectionObserver;

    constructor(oiAnim: HTMLElement) {
        this.oiAnim = oiAnim;
        this.hasScrolled = false;

        // Initialize observer to manage section visibility
        this.initObserver();

        // Add scroll listener
        window.addEventListener('load', this.handleScroll.bind(this), { passive: true, once: true });
    }

    private initObserver() {
        this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
            threshold: 0.001,
        });

        this.observer.observe(this.oiAnim);
    }

    private handleIntersection(entries: IntersectionObserverEntry[]) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                // Section is in viewport, make it visible
                this.oiAnim.classList.remove('js-will-animate');
                this.oiAnim.classList.add('js-animate');
                this.oiAnim.style.opacity = '1';
            }
        });
    }

    private handleScroll() {
        if (!this.hasScrolled) {
            this.hasScrolled = true;
            requestAnimationFrame(() => {
                this.checkSectionsBelowViewport();
                this.hasScrolled = false;
            });
        }
    }

    private checkSectionsBelowViewport() {
        const viewportHeight = window.innerHeight;
        const sectionTop = this.oiAnim.getBoundingClientRect().top;

        if (sectionTop > viewportHeight) {
            // Section is below the viewport, set content to null
            this.oiAnim.style.opacity = '0';
            this.oiAnim.classList.add('js-will-animate');
            this.oiAnim.classList.remove('js-animate');
        }
    }
}

export default OiAnim;
